import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const STATUS_COLORS = {
  new: "bg-[#E8F5F2] text-[#14A085]",
  accepted: "bg-[#E8F5F2] text-[#14A085]",
  processing: "bg-amber-100 text-amber-700",
  shipped: "bg-blue-100 text-blue-700",
  delivered: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/my").then(({ data }) => setOrders(data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-10 text-center text-[#3B5249]">Loading…</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.2em] text-[#14A085]">Track</div>
      <h1 className="font-display text-3xl md:text-4xl text-[#0F3D2E]">My Orders</h1>

      {orders.length === 0 ? (
        <div className="mt-8 rounded-xl border border-dashed border-[#E2E8E5] bg-white p-12 text-center" data-testid="no-orders">
          <p className="text-[#3B5249]">No orders yet.</p>
          <Link to="/products" className="text-[#14A085] hover:underline">Start shopping →</Link>
        </div>
      ) : (
        <div className="mt-8 space-y-4" data-testid="orders-list">
          {orders.map((o) => (
            <div key={o.id} className="rounded-xl border border-[#E2E8E5] bg-white p-5" data-testid={`order-${o.id}`}>
              <div className="flex flex-wrap justify-between gap-3 pb-3 border-b border-[#E2E8E5]">
                <div>
                  <div className="text-xs text-[#6E877C]">Order</div>
                  <div className="font-mono text-sm text-[#0F3D2E]">#{o.id.slice(-8).toUpperCase()}</div>
                </div>
                <div>
                  <div className="text-xs text-[#6E877C]">Placed</div>
                  <div className="text-sm text-[#0F3D2E]">{new Date(o.created_at).toLocaleString()}</div>
                </div>
                <div>
                  <div className="text-xs text-[#6E877C]">Payment</div>
                  <div className="text-sm text-[#0F3D2E] capitalize">{o.payment_method?.replace("_"," ")}</div>
                </div>
                <div>
                  <div className="text-xs text-[#6E877C]">Total</div>
                  <div className="font-semibold text-[#0F3D2E]">₹{o.total.toLocaleString()}</div>
                </div>
              </div>
              <div className="mt-3 space-y-2">
                {o.items.map((it) => (
                  <div key={it.item_id} className="flex items-center gap-3 text-sm">
                    <img src={it.image} alt="" className="w-12 h-12 rounded object-cover" />
                    <div className="flex-1">
                      <div className="text-[#0F3D2E]">{it.title}</div>
                      <div className="text-xs text-[#6E877C]">Qty {it.qty} · by {it.vendor_name}</div>
                      {it.awb && (
                        <a href={`/track/${it.awb}`} className="text-xs text-[#14A085] hover:underline" data-testid={`track-link-${it.item_id}`}>
                          Track AWB {it.awb}
                        </a>
                      )}
                    </div>
                    <span className={`text-xs px-2 py-1 rounded-full capitalize ${STATUS_COLORS[it.status] || "bg-gray-100 text-gray-700"}`}>{it.status}</span>
                    <div className="text-[#0F3D2E] w-20 text-right">₹{(it.price*it.qty).toLocaleString()}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
